import moment from 'moment';
import { TableRow, TableCell } from '@material-ui/core';

import { BookingInformationIcon } from '../../icons';
import ActionIconButton from '../../components/atom/ActionIconButton';
import GuestActionButtons from '../../components/atom/GuestActionButtons';

// Once custom_booking_id is set, the custom booking's own time is the real
// serving time — activity_start stays the original predefined slot. Same
// precedence rule as fullwidget's bookingsColumns.tsx.
function resolveActivityStart(booking_item) {
    if (booking_item?.custom_booking_id != null) {
        return booking_item?.custom_booking?.activity_start ?? booking_item?.activity_start;
    }
    return booking_item?.activity_start;
}

const UnconfirmedBookingTableRow = ({
    booking_item,
    customer,
    loginAsCustomerWithId,
    cartItemCount,
    showModal
}) => {
    const guestName = booking_item?.booking.user?.firstname
        ? `${booking_item?.booking.user?.firstname} ${booking_item?.booking.user?.lastname}`
        : '-';

    const agentName = booking_item?.booking.agent?.firstname
        ? `${booking_item?.booking.agent?.firstname} ${booking_item?.booking.agent?.lastname}`
        : '-';

    const vendorName = booking_item?.activity.company?.name || '-';
    const activityName = booking_item?.activity?.name || '-';

    return (
        <TableRow hover>
            <TableCell>{guestName}</TableCell>
            <TableCell>{agentName}</TableCell>
            <TableCell>{vendorName}</TableCell>
            <TableCell>{booking_item?.id}</TableCell>
            <TableCell>{activityName}</TableCell>
            <TableCell>
                {resolveActivityStart(booking_item)
                    ? moment.utc(resolveActivityStart(booking_item)).format('MM/DD/YYYY, h:mm a')
                    : '-'}
            </TableCell>
            <TableCell>
                {typeof booking_item?.amount === 'number'
                    ? `$${booking_item.amount.toFixed(2)}`
                    : '-'}
            </TableCell>
            <TableCell style={{ width: 140 }}>
                <ActionIconButton
                    title="Booking informations"
                    icon={BookingInformationIcon}
                    to={`/client/bookings/${booking_item.id}`}
                />
                {booking_item?.booking?.user && (
                    <GuestActionButtons
                        customer={customer}
                        guestId={booking_item?.booking?.guest_id}
                        loginAsCustomerWithId={loginAsCustomerWithId}
                        cartItemCount={cartItemCount}
                        showModal={showModal}
                    />
                )}
            </TableCell>
        </TableRow>
    );
};

export default UnconfirmedBookingTableRow;
